import React from 'react';
import EducationReportView from './reports/EducationReportView';

/**
 * Eğitim Raporları (Tailwind): every active employee's SOP / training
 * completion from the real records. Screen: EducationReportView.
 */
const EducationReportsPage = () => <EducationReportView mode="all" />;

export default EducationReportsPage;
